<template>
  <div class="exclusive-service">
    <!-- 顶部导航栏 -->
    <AppHeader />

    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-background">
        <div class="city-skyline">
          <img src="@/images/index2.png" alt="港口背景" class="skyline-image" />
        </div>
      </div>
      <div class="banner-content">
        <h1 class="banner-title">服务介绍</h1>
        <p class="banner-subtitle">专属服务</p>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧导航菜单 -->
      <SidebarNav :activeItem="'exclusive-service'" />

      <!-- 右侧内容区域 -->
      <main class="content">
        <!-- 服务介绍区域 -->
        <section class="service-intro">
          <div class="section-header">
            <h2 class="section-number">01</h2>
            <h3 class="section-title">服务介绍</h3>
            <button class="submit-btn" @click="showModal = true">申请服务</button>
          </div>
          
          <div class="service-cards">
            <div class="service-card">
              <p class="card-description">株洲高科汽车园经营管理有限公司作为“株洲市外贸综合服务中心”，可根据企业需求，提供外贸出口全链条解决方案，涵盖合同审核、国际物流配送、专业报关报检、跨境收结汇以及出口退税等一站式服务，确保企业出口无忧，助力企业合规高效开拓国际市场。</p>
            </div>
          </div>
        </section>

        <!-- 服务流程区域 -->
        <section class="service-process">
          <div class="section-header">
            <h2 class="section-number">02</h2>
            <h3 class="section-title">服务流程</h3>
          </div>
          
          <div class="process-steps">
            <div class="step" v-for="(step, index) in processSteps" :key="index">
              <div class="step-circle">
                <span class="step-number">{{ index + 1 }}</span>
              </div>
              <div class="step-content">
                <h4 class="step-title">{{ step.title }}</h4>
              </div>
              <div v-if="index < processSteps.length - 1" class="step-line"></div>
            </div>
          </div>
        </section>
        <!-- 专业机构入驻区域 -->
        <section class="institution-section">
          <div class="section-header">
            <h2 class="section-number">03</h2>
            <h3 class="section-title">入驻机构</h3>
          </div>
          <InstitutionEntry :institutions="institutions" />
        </section>
      </main>
    </div>
    
    <!-- 底部区域 -->
    <AppFooter />
    
    <!-- 提交需求模态框 -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>提交需求</h3>
          <button class="close-btn" @click="closeModal">×</button>
        </div>
        <el-form class="modal-form" :model="formData" :rules="formRules" ref="submitForm" @submit.native.prevent="submitForm">
          <el-form-item label="企业名称" prop="companyName" required>
            <el-input 
              v-model="formData.companyName" 
              placeholder="请输入企业名称"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="企业需求" prop="companyDescription" required>
            <el-input 
              type="textarea"
              v-model="formData.companyDescription" 
              placeholder="请输入企业需求"
              :rows="4"
              maxlength="240"
              show-word-limit
            ></el-input>
          </el-form-item>
          
          <el-form-item label="企业负责人" prop="contactPerson" required>
            <el-input 
              v-model="formData.contactPerson" 
              placeholder="请输入企业负责人"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="联系方式" prop="contactPhone" required>
            <el-input 
              v-model="formData.contactPhone" 
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          
          <div class="form-footer">
             <div class="service-phone">
               服务热线电话：0731-28666027
             </div>
             <div class="form-buttons">
               <el-button @click="closeModal">取消</el-button>
               <el-button type="primary" @click="submitForm">提交</el-button>
             </div>
           </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import SidebarNav from './SidebarNav.vue'
import api from '@/utils/api'
import InstitutionEntry from './InstitutionEntry'

export default {
  name: 'ExclusiveService',
  components: {
    AppHeader,
    AppFooter,
    SidebarNav,
	InstitutionEntry
  },
  data() {
    return {
      showModal: false,
      formData: {
        companyName: '',
        companyDescription: '',
        contactPerson: '',
        contactPhone: ''
      },
      formRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        companyDescription: [
          { required: true, message: '请输入企业需求', trigger: 'blur' },
          { max: 240, message: '企业需求不能超过240个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入企业负责人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      processSteps: [
        { title: '提出申请' },
        { title: '1小时接单（咨询解答）' },
		{ title: '派单' },
		{ title: '政务服务' },
		{ title: '专业服务' },
		{ title: '回复' }
      ],
      institutions: [
        { url: 'https://a.hnjsxk.com/chuhaiban/serivce/WechatIMG9123.jpg', alt: '国际储运机构3' }
      ]
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    async submitForm() {
      this.$refs.submitForm.validate(async (valid) => {
        if (valid) {
          try {
            const requestData = {
              type: 17, // 专属服务
              applicationType: 1,
              name: this.formData.companyName,
              person: this.formData.contactPerson,
              phone: this.formData.contactPhone,
              demand: this.formData.companyDescription
            };
            
            await api.submitDemand(requestData);
            
            this.$message.success('需求提交成功！我们会尽快与您联系。');
            
            // 重置表单并关闭模态框
            this.$refs.submitForm.resetFields();
            this.closeModal();
          } catch (error) {
            console.error('提交失败:', error);
            this.$message.error('提交失败，请稍后重试');
          }
        } else {
          this.$message.error('请正确填写所有必填字段');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.exclusive-service {
  width: 100%;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  background-color: white;
  padding-top: 0;
}

/* Banner区域样式 */
.banner {
  position: relative;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.city-skyline {
  left: 0;
  width: 100%;
  height: 100%;
}

.skyline-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-subtitle {
  font-size: 20px;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* 主要内容区域 */
.main-content {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  gap: 20px;
  background-color: white;
  min-height: calc(100vh - 300px);
}

/* 右侧内容区域 */
.content {
  flex: 1;
  background: white;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #e0e0e0;
  padding: 30px;
}

/* 区域标题 */
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.section-number {
  color: #4A90E2;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  flex: 1;
}

.submit-btn {
  background: #1665DA;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 23px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  background: #357ABD;
}

/* 服务卡片 */
.service-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 40px;
}

.service-card {
  border: none;
  border-radius: 0;
  padding: 15px 0;
  position: relative;
  background: white;
  border-bottom: 1px solid #f0f0f0;
}

.service-card:last-child {
  border-bottom: none;
}

.card-tag {
  background: linear-gradient(90deg, #2F86FF 0%, #0057D6 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 8px;
}

.card-description {
  color: #666;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
}

/* 流程步骤 */
.process-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 20px 0;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
}

.step-circle {
  background: #4A90E2;
  color: white;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  z-index: 2;
}

.step-number {
  color: white;
  font-weight: bold;
  font-size: 16px;
}

.step-content {
  flex: 1;
}

.step-title {
  color: #333;
  font-size: 14px;
  text-align: center;
  margin: 0;
  white-space: nowrap;
}

.step-line {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #4A90E2;
  z-index: 1;
}

/* 服务优势 */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.advantage-item {
  text-align: center;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.advantage-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.advantage-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.advantage-item h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 10px 0;
  color: #333;
}

.advantage-item p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #666;
}

/* Element UI 表单样式调整 */
.modal-form .el-form-item.is-required .el-form-item__label::before {
  content: '*';
  color: #f56c6c !important;
  margin-right: 4px;
  font-weight: bold;
}

.modal-form .el-form-item.is-required .el-form-item__label::after {
  content: '' !important;
}

/* 隐藏Element UI默认的星号 */
.modal-form .el-form-item__label .el-form-item__asterisk {
  display: none !important;
}

.modal-form {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4A90E2;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #999;
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.form-footer {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.service-phone {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  text-align: center;
}

.form-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.cancel-btn,
.confirm-btn {
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn {
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  color: #666;
}

.cancel-btn:hover {
  background: #e8e8e8;
}

.confirm-btn {
  background: #4A90E2;
  border: 1px solid #4A90E2;
  color: white;
}

.confirm-btn:hover {
  background: #357ABD;
  border-color: #357ABD;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
    padding: 10px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .service-cards {
    grid-template-columns: 1fr;
  }
  
  .process-steps {
    flex-direction: column;
    gap: 20px;
  }
  
  .step-line {
    display: none;
  }
  
  .modal-content {
    width: 95vw;
    margin: 20px;
  }
  
  .modal-form {
    padding: 16px;
  }
  
  .form-buttons {
    flex-direction: column;
  }
  
  .cancel-btn,
  .confirm-btn {
    width: 100%;
  }
}
</style>